export default __webpack_public_path__ + "locales/de/VersionHistory.json?hash=2a354cc90a16bc5429d3e33acfdcc91e";